import { Action } from '@actions/types';
import { inject, Injectable } from '@angular/core';
import { DeviceStore } from '@app/store/device';
import { PersistenceResource } from '@infra/persistence';
import { QueryParamsResource } from '@infra/query-params';
import { UtmsResource } from '@infra/utms';

export interface IShouldHandleInformationsAction extends Action<void, boolean> {}

@Injectable({ providedIn: 'root' })
export class ShouldHandleInformationsAction implements IShouldHandleInformationsAction {
  private utmResource = inject(UtmsResource);
  private deviceStore = inject(DeviceStore);
  private persistenceResource = inject(PersistenceResource);
  private queryParamsResource = inject(QueryParamsResource);

  run(): boolean {
    const utms = this.utmResource.getUtms();
    const queryParams = this.queryParamsResource.getCurrent();
    const landing_page_fallback = this.persistenceResource.getLandingPageFallback();
    return (
      !!landing_page_fallback ||
      utms?.utm_source === 'app-garcom' ||
      this.deviceStore.isMobileApp()
    );
  }
}
